
import {
  REQUEST_CUSTOMERS,
  REQUEST_CUSTOMERS_ERROR,
  RECEIVE_CUSTOMERS,
  REQUEST_FIND_CUSTOMERS,
  RECEIVE_FIND_CUSTOMERS,
  REQUEST_FIND_CUSTOMERS_ERROR
} from 'actions'

export default (state = {}, { type, payload }) => {
  switch (type) {
    case REQUEST_CUSTOMERS:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          didRequestFail: false,
          isRequesting: true
        }
      }
    case REQUEST_FIND_CUSTOMERS:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          searchResult: {
            isRequesting: true,
            didRequestFail: false
          }
        }
      }
    case REQUEST_CUSTOMERS_ERROR:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          isRequesting: false,
          didRequestFail: true
        }
      }
    case REQUEST_FIND_CUSTOMERS_ERROR:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          searchResult: {
            isRequesting: false,
            didRequestFail: true
          }
        }
      }
    case RECEIVE_CUSTOMERS:
      const previousCustomers = state[payload.workspaceSlug].data || []
      const newCustomers = payload.response.data || []
      const customers = previousCustomers.concat(newCustomers)

      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          isRequesting: false,
          didRequestFail: false,
          cursor: payload.response.cursor,
          data: customers
        }
      }
    case RECEIVE_FIND_CUSTOMERS:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          searchResult: {
            data: [ payload.response ],
            isRequesting: false,
            didRequestFail: false
          }
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/customers.js